export default __webpack_public_path__ + "static/mediaFlagOne-dd6cb6deb5a48b5ec638c09056dd6b57.png";